/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Telemetry_Group = {
    workspaceId: string;
    projectId: string;
    traits?: {
        /**
         * The filters to apply on the data when running the query
         */
        filters?: Array<{
            /**
             * The filters to apply on the data in this group
             */
            filters?: Array<{
                key: string;
                operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                value?: (string | number | boolean);
                type: 'string' | 'number' | 'boolean' | 'array';
            }>;
            /**
             * How to combine the filters in this group
             */
            filterCombination?: 'and' | 'or';
        }>;
        /**
         * Expression to search on the data when running the query
         */
        needle?: {
            value: (string | number | boolean);
            isRegex?: boolean;
            matchCase?: boolean;
        };
        /**
         * How to combine the filters across groups
         */
        filterCombination?: Telemetry_Group.filterCombination;
    };
    limit?: number;
    offset?: string;
    offsetDirection?: Telemetry_Group.offsetDirection;
};
export namespace Telemetry_Group {
    /**
     * How to combine the filters across groups
     */
    export enum filterCombination {
        AND = 'and',
        OR = 'or',
    }
    export enum offsetDirection {
        NEXT = 'next',
        PREV = 'prev',
    }
}

